import { useCallback } from "react";
import { readAtom, useAtomValue } from "@mdotm/shadcn/legacy/reactivity";
import type { ColumnState } from "ag-grid-community";
import { useWorkspaceSlices } from "../state";

export function useWorkspaceColumns(): {
	getWorkspaceColumns(): ColumnState[] | undefined;
	watchWorkspaceColumns(): ColumnState[] | undefined;
} {
	// "Which columns render a concept" is a question about state, so it is a slice rather than a filter each
	// caller remembers — see `selectConceptColumns`.
	const { conceptColumns$ } = useWorkspaceSlices();

	const getWorkspaceColumns = useCallback(() => readAtom(conceptColumns$), [conceptColumns$]);

	const columns = useAtomValue(conceptColumns$);
	const watchWorkspaceColumns = useCallback(() => columns, [columns]);

	return { getWorkspaceColumns, watchWorkspaceColumns };
}
